import React from "react";
import "./performance.css";
import { formatDate } from "../../../components/common/Converter";

function IpcrListPrint(object) {
  console.log("OBEJCT: ", object);
  const performance = object?.performance || [];
  const employee =
    `${object?.assignedEmployee?.Firstname || ""} ${
      object?.assignedEmployee?.Middlename || ""
    } ${object?.assignedEmployee?.surname || ""}` || "";
  const supervisor = `${object?.supervisor?.Firstname || ""} ${
    object?.supervisor?.Middlename || ""
  } ${object?.supervisor?.surname || ""}`;

  const employeePosition =
    object?.assignedEmployee?.position?.position_title || "";
  const supervisorPosition = object?.supervisor?.position?.position_title || "";

  const periodDate = `${formatDate(object?.periodFrom).toUpperCase() || ""} - ${
    formatDate(object?.periodTo).toUpperCase() || ""
  }`;
  const headingStyle = {
    // fontWeight: "bold",
    // margin: "0 0 5px 2rem",
    paddingRight: "3rem",
    marginTop: 0,
  };

  const textStyle = {
    margin: "0px 0",
    display: "flex",
    justifyContent: "space-between",
    border: "1px solid black",
  };

  const tableHead = (title, width, span) => {
    return (
      <th
        style={{
          width: width,
          wordWrap: "break-word",
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "11px",
        }}
        rowSpan={span}
      >
        <div dangerouslySetInnerHTML={{ __html: title }} />
      </th>
    );
  };

  return (
    <>
      <div
        style={{
          width: "100%",
          margin: 0,
          padding: "2px",
        }}
      >
        <div
          style={{
            // padding: "1rem",
            border: "1px solid black",
            marginRight: "5px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between", // Ensures elements are spaced properly
              border: "1px solid",
              alignItems: "center", // Aligns items vertically
              width: "100%", // Ensures full-width alignment
              marginBottom: "1rem",
            }}
          >
            <div style={{ display: "grid", width: "87%" }}>
              <div
                style={{
                  fontWeight: "bold",
                  paddingLeft: "45%",
                }}
              >
                Bureau of Immigration
              </div>
              <div style={{ textAlign: "center" }}>
                HUMAN RESOURCE DEVELOPEMMENT DIVISION (HRDD) / HUMAN RESOURCES
                MANAGEMENT SECTION (HRMS)
              </div>
            </div>
            <div
              style={{
                width: "8%",
                padding: "5px",
                textAlign: "center",
                border: "1px solid black",
                fontSize: "10px",
              }}
            >
              <span>
                BI SPMS <b>ANNEX B</b>
              </span>
              <br />
              <span>2015</span>
            </div>
          </div>
          <div style={{ padding: "1rem" }}>
            <p>a.</p>
            <div style={{ textAlign: "center", fontWeight: "bold" }}>
              INDIVIDUAL PERFORMANCE COMMITMENT AND REVIEW (IPCR)
            </div>
            <div>
              <p style={{ textAlign: "justify" }}>
                I, <b>{employee}</b>, <b>{employeePosition}</b>, commit to
                deliver and agree to be rated on the attainment of the following
                targets in accordance with the indicated measures for the period
                of <b>{periodDate}</b>.
              </p>
            </div>
            <div
              style={{
                display: "flex",
                margin: "1rem 0",
              }}
            >
              {/* Column 2 */}
              <div
                style={{
                  width: "60%",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <p style={headingStyle}>Rating Scale</p>
                <div
                  style={{
                    width: "170px",
                    padding: "5px",
                  }}
                >
                  {/* <p style={headingStyle}>Rating:</p> */}
                  <div style={textStyle}>
                    <label>Outstanding</label>
                    <label
                      style={{
                        width: "1rem",
                        borderLeft: "1px solid black",
                        textAlign: "center",
                      }}
                    >
                      5
                    </label>
                  </div>
                  <div style={textStyle}>
                    <label>Very Satisfactory</label>
                    <label
                      style={{
                        width: "1rem",
                        borderLeft: "1px solid black",
                        textAlign: "center",
                      }}
                    >
                      4
                    </label>
                  </div>
                  <div style={textStyle}>
                    <label>Satisfactory</label>
                    <label
                      style={{
                        width: "1rem",
                        borderLeft: "1px solid black",
                        textAlign: "center",
                      }}
                    >
                      3
                    </label>
                  </div>
                  <div style={textStyle}>
                    <label>Unsatisfactory</label>
                    <label
                      style={{
                        width: "1rem",
                        borderLeft: "1px solid black",
                        textAlign: "center",
                      }}
                    >
                      2
                    </label>
                  </div>
                  <div style={textStyle}>
                    <label>Poor</label>
                    <label
                      style={{
                        width: "1rem",
                        borderLeft: "1px solid black",
                        textAlign: "center",
                      }}
                    >
                      1
                    </label>
                  </div>
                </div>
              </div>
              {/* ratee  */}
              <div
                style={{
                  width: "40%",
                  alignSelf: "left",
                }}
              >
                <div style={{ paddingLeft: "40%", fontSize: "13px" }}>
                  <span style={{ textAlign: "center" }}>
                    <p
                      style={{
                        fontWeight: "bold",
                        textDecoration: "underline",
                      }}
                    >
                      {employee}
                    </p>
                    <p style={{ marginTop: "-12px" }}>Ratee</p>
                    <p style={{ marginTop: "-12px" }}>
                      Date: {formatDate(object?.periodFrom)}
                    </p>
                  </span>
                </div>
              </div>
            </div>
            <div
              style={{
                fontSize: "12px",
              }}
            >
              <table
                border="1"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  tableLayout: "fixed",
                }}
              >
                <thead></thead>
                <tbody>
                  <tr style={{ fontSize: "12px", fontWeight: "bold" }}>
                    <td> b. Reviewed by:</td>
                    <td> Date</td>
                    <td> c. Approved by:</td>
                    <td> Date</td>
                  </tr>
                  <tr style={{ fontSize: "13px" }}>
                    <td style={{ textAlign: "center" }}>
                      {/* {supervisor} */}
                      <b>{object?.headName}</b>
                      <br />
                      <hr style={{ padding: 0, margin: 0 }} />
                      <span style={{ fontSize: "10px" }}>
                        Immediate Supervisor:
                      </span>
                    </td>
                    <td style={{ textAlign: "center" }}></td>
                    <td style={{ textAlign: "center" }}>
                      {/* {object?.headName} */}
                      <b>{object?.finalName}</b>
                      <br />
                      <hr style={{ padding: 0, margin: 0 }} />
                      <span style={{ fontSize: "10px" }}>Head of Office:</span>
                    </td>
                    <td style={{ textAlign: "center" }}></td>
                  </tr>
                </tbody>
              </table>
              <table
                border="1"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  tableLayout: "fixed",
                }}
              >
                <colgroup>
                  <col style={{ width: "15%" }} /> {/* Major Final Output */}
                  <col style={{ width: "15%" }} /> {/* Success Indicators */}
                  <col style={{ width: "15%" }} />
                  <col style={{ width: "6%" }} /> {/* % Distribution */}
                  <col style={{ width: "6%" }} /> {/* Q¹ */}
                  <col style={{ width: "6%" }} /> {/* E² */}
                  <col style={{ width: "6%" }} /> {/* T³ */}
                  <col style={{ width: "11%" }} /> {/* A⁴ */}
                  <col style={{ width: "10%" }} /> {/* Ave. Score */}
                  <col style={{ width: "15%" }} /> {/* Remarks */}
                </colgroup>
                <thead
                  style={{
                    display: "table-row-group", // Ensures no special treatment for headers
                    whiteSpace: "normal",
                    wordWrap: "break-word",
                  }}
                >
                  <tr style={{ fontSize: "12px" }}>
                    {tableHead("Major Final Output", "", 2)}
                    {tableHead(
                      "Success Indicators (Targets + Measures)",
                      "",
                      2
                    )}
                    {tableHead("Actual Accomplishments", "", 2)}
                    {tableHead("%<br/>Distribution", "4.5rem", 2)}
                    <th
                      colSpan="4"
                      style={{
                        width: "17%",
                        padding: "5px",
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: "11px",
                      }}
                      rowSpan={1}
                    >
                      Rating
                    </th>
                    {tableHead("Ave. Score", "4.5rem", 2)}
                    {tableHead("Remarks", "", 2)}
                  </tr>
                  <tr style={{ fontSize: "12px" }}>
                    {Array.from({ length: 4 }, (_, index) => {
                      const labels = ["Q¹", "E²", "T³", "A⁴"];
                      return (
                        <th
                          key={index}
                          style={{
                            textAlign: "center",
                            fontSize: "12px",
                            padding: 0,
                            margin: 0,
                          }}
                        >
                          {labels[index]}
                        </th>
                      );
                    })}
                  </tr>
                  <tr>
                    {Array.from({ length: 10 }, (_, index) => {
                      const labels = [
                        "(d)",
                        "(e)",
                        "(f)",
                        "(g)",
                        "(h)",
                        "(i)",
                        "(j)",
                        "(k = ave of h, i, j)",
                        "l = g x k",
                        "(m)",
                      ];
                      return (
                        <th
                          key={index}
                          style={{
                            textAlign: "center",
                            fontSize: `${index === 7 ? "9px" : "11px"}`,
                            whiteSpace: "nowrap",
                            width: "auto",
                          }}
                        >
                          {labels[index]}
                        </th>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {performance.map((data, index) => {
                    console.log("DATA:::  ", data);
                    return (
                      <tr
                        key={index}
                        style={{
                          pageBreakInside: "avoid", // Prevents rows from breaking across pages
                          fontSize: "12px",
                        }}
                      >
                        <td
                          style={{
                            padding: "5px",
                            wordWrap: "break-word",
                            textAlign: "left",
                          }}
                        >
                          {data?.output}
                        </td>
                        <td
                          style={{
                            padding: "5px",
                            wordWrap: "break-word",
                            textAlign: "left",
                          }}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: data?.successindicators?.replace(
                                /\n/g,
                                "<br />"
                              ),
                            }}
                          />
                        </td>
                        <td
                          style={{
                            padding: "5px",
                            wordWrap: "break-word",
                            textAlign: "left",
                          }}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: data?.actualaccomplishments?.replace(
                                /\n/g,
                                "<br />"
                              ),
                            }}
                          />
                        </td>
                        <td
                          style={{
                            padding: "5px",
                            wordWrap: "break-word",
                            textAlign: "center",
                          }}
                        >
                          {Number(data?.distribution || 0)} %
                        </td>
                        <td
                          style={{
                            padding: "5px",
                            textAlign: "center",
                          }}
                        >
                          {Number(data?.quality || 0).toFixed(2)}
                        </td>
                        <td
                          style={{
                            padding: "5px",
                            textAlign: "center",
                          }}
                        >
                          {Number(data?.efficiency || 0).toFixed(2)}
                        </td>
                        <td
                          style={{
                            padding: "5px",
                            textAlign: "center",
                          }}
                        >
                          {Number(data?.timeliness || 0).toFixed(2)}
                        </td>
                        <td
                          style={{
                            padding: "5px",
                            textAlign: "center",
                          }}
                        >
                          {Number(data?.average || 0).toFixed(2)}
                        </td>
                        <td
                          style={{
                            padding: "5px",
                            wordWrap: "break-word",
                            textAlign: "center",
                          }}
                        >
                          {Number(data?.averagedeci || 0).toFixed(2)}
                        </td>
                        <td
                          style={{
                            padding: "5px",
                            wordWrap: "break-word",
                            textAlign: "left",
                          }}
                        >
                          {data?.remarks ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: data?.remarks?.replace(/\n/g, "<br />"),
                              }}
                            />
                          ) : (
                            ""
                          )}
                        </td>
                      </tr>
                    );
                  })}
                  {/* <tr style={{ fontSize: "12px" }}>
                  <td
                    style={{
                      padding: "5px",
                      wordWrap: "break-word",
                      textAlign: "center",
                    }}
                    colSpan={7}
                  >
                    TOTAL RATING
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      wordWrap: "break-word",
                      textAlign: "center",
                    }}
                    colSpan={3}
                  >
                    {performance
                      .reduce((sum, item) => sum + item.average, 0)
                      .toFixed(2)}
                  </td>
                </tr>
                <tr style={{ fontSize: "12px" }}>
                  <td
                    style={{
                      padding: "5px",
                      wordWrap: "break-word",
                      textAlign: "center",
                    }}
                    colSpan={7}
                  >
                    FINAL AVERAGE RATING
                  </td>
                  <td
                    style={{
                      padding: "5px",
                      wordWrap: "break-word",
                      textAlign: "center",
                    }}
                    colSpan={3}
                  >
                    {performance
                      .reduce(
                        (sum, item) => sum + item.average / performance.length,
                        0
                      )
                      .toFixed(2)}
                  </td>
                </tr> */}
                  <tr style={{ fontSize: "12px" }}>
                    <td
                      style={{
                        padding: "5px 0",
                        wordWrap: "break-word",
                      }}
                      colSpan={7}
                    >
                      <p style={{ fontSize: "12px" }}>
                        o. Final Average Rating
                      </p>
                    </td>
                    <td
                      style={{
                        padding: "5px",
                        wordWrap: "break-word",
                        textAlign: "center",
                      }}
                      colSpan={3}
                    >
                      {performance
                        .reduce(
                          (sum, item) => sum + parseFloat(item.averagedeci),
                          0
                        )
                        .toFixed(2)}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={10}>
                      <p style={{ fontSize: "12px" }}>
                        p. Comments and Recommendations from Development
                        Purposes (please use staff Development plan form)
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={10} style={{ height: "1rem" }}></td>
                  </tr>
                  <tr>
                    <td colSpan={10} style={{ height: "1rem" }}></td>
                  </tr>
                  <tr>
                    <td colSpan={10} style={{ height: "1rem" }}></td>
                  </tr>
                </tbody>
              </table>
              <table
                border="1"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  tableLayout: "fixed",
                }}
              >
                <thead>
                  <tr style={{ fontSize: "12px" }}>
                    <th style={{ fontWeight: "bold" }}>q. Discussed With</th>
                    <th style={{ fontWeight: "bold" }}>Date</th>
                    <th style={{ fontWeight: "bold" }}>r. Assessed by:</th>
                    <th style={{ fontWeight: "bold" }}>Date</th>
                    <th style={{ fontWeight: "bold" }}>s. Final Rating by:</th>
                    <th style={{ fontWeight: "bold" }}>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style={{ fontSize: "12px" }}>
                    <td>
                      <div style={{ height: "6rem", margin: 0 }} />
                      <div style={{ display: "grid", textAlign: "center" }}>
                        <b>{employee}</b>
                        <i>Name and Signature of Employee</i>
                      </div>
                    </td>
                    <td></td>
                    <td>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "12px",
                          height: "7rem",
                          margin: 0,
                        }}
                      >
                        <label>
                          I certify that I discussed my assessment of the
                          performance with the employee.
                        </label>
                      </div>
                      <div
                        style={{
                          display: "grid",
                          alignItems: "baseline",
                          textAlign: "center",
                        }}
                      >
                        <b>{object?.headName}</b>
                        <i>{object?.headPosition}</i>
                      </div>
                    </td>
                    <td></td>
                    <td>
                      <div style={{ height: "6rem", margin: 0 }} />
                      <div
                        style={{
                          display: "grid",
                          textAlign: "center",
                        }}
                      >
                        <b>{object?.finalName}</b>
                        <i>{object?.finalPosition}</i>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td colSpan={6}>
                      <div
                        style={{
                          display: "flex",
                          gap: "3rem",
                          fontSize: "12px",
                        }}
                      >
                        <label>Legend: </label>
                        <label>1 - Quality </label>
                        <label>2 - Efficiency </label>
                        <label>3 - Timeliness </label>
                        <label>4 - Average </label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default IpcrListPrint;
